import { marqueeItems } from "../../data/portfolioData";

export const MarqueeStrip = () => {
  const items = [...marqueeItems, ...marqueeItems];
  return (
    <div className="relative border-y border-white/[0.06] bg-[#0A0D15]/60 py-5 overflow-hidden" data-testid="marquee-strip">
      <div className="marquee-track flex whitespace-nowrap w-max">
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-lg sm:text-xl font-medium text-slate-500 tracking-wide px-6">{item}</span>
            <span className="text-amber-400/60 text-sm">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};
